const form = {
  formId: "tax-personal-05",
  formField: {
    organizeName: {
      name: "organ1",
      label: "Tên tổ chức, cá nhân trả thu nhập",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức, cá nhân trả thu nhập",
    },
    taxId: {
      name: "taxId",
      label: "Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    checkbox1: {
      name: "checkbox1",
      label: "01/TKN - XSBHĐC",
    },
    checkbox2: {
      name: "checkbox2",
      label: "02/QTT - TNCN",
    },
    checkbox3: {
      name: "checkbox3",
      label: "05/QTT - TNCN",
    },
    checkbox4: {
      name: "checkbox4",
      label: "05/DS - TNCN",
    },
    checkbox5: {
      name: "checkbox5",
      label: "Mẫu QT khác và các bảng kê (NNT tự nghi mẫu tờ khai quyết toán ở bên dưới)",
    },
  },
};

export default form;
